// import ScaleLoader from "react-spinners/ScaleLoader";
import { motion } from "framer-motion";

export default function LoadingButton() {
  return (
    <div className="flex space-x-1 h-5 justify-center items-center">
      {[ "#FFA100", "#144EA2", "#FFA100" ].map((color, index) => (
        <motion.div
          key={index}
          className="w-1.5 rounded-md"
          initial={{ height: "20%" }}
          animate={{ height: ["20%", "100%", "20%"] }}
          transition={{
            duration: 1,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
            delay: index * 0.2, // Stagger animation
          }}
          style={{ backgroundColor: color }}
        />
      ))}
    </div>

  );
}